import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../components/SEO";
import Hero from "../components/sections/Hero";
import Problem from "../components/sections/Problem";
import Solution from "../components/sections/Solution";
import HtcIntro from "../components/sections/HtcIntro";
import SelfDiscoverySection from "../components/sections/SelfDiscoverySection";
import StartHereTeaser from "../components/sections/StartHereTeaser";
import Mentor from "../components/sections/Mentor";
import Themes from "../components/sections/Themes";
import Offerings from "../components/sections/Offerings";
import Testimonials from "../components/sections/Testimonials";
import Community from "../components/sections/Community";
import FollowMovement from "../components/sections/FollowMovement";
import FinalCtaContact from "../components/sections/FinalCtaContact";
import HomepageBarometerTeaser from "../components/sections/HomepageBarometerTeaser";

// Für MVL öffentlich nicht vermarktet — Import bleibt zum späteren Re-Enable erhalten:
// import Ecosystem from "../components/sections/Ecosystem";
// import LeadMagnet from "../components/sections/LeadMagnet";
// import PartnerProjekte from "../components/sections/PartnerProjekte";
// import PartnerSpotlight from "../components/PartnerSpotlight";

const Home = () => {
  const loc = useLocation();
  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [loc.pathname, loc.hash]);

  return (
    <div data-testid="home-page">
      <SEO
        title="SAT — Schweizer Akademie für Transformation"
        description="Du bist nicht falsch. Du bist verschlüsselt. Die SAT Akademie begleitet Menschen mit dem SAT-HTC™ Human Transformation Code — SAT MASTER, SAT MENTOR und Herzbewegung."
        path="/"
      />
      <Hero />
      <Problem />
      <HomepageBarometerTeaser />
      <Solution />
      <HtcIntro />
      <SelfDiscoverySection />
      <StartHereTeaser />
      <Mentor />
      <Themes />
      <Offerings />
      <Testimonials />
      <Community />
      <FollowMovement />
      <FinalCtaContact />
    </div>
  );
};

export default Home;
